<template>
	<svg
		width="16"
		height="20"
		viewBox="0 0 16 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15 18.75L12.69 9.75C13.5441 8.68737 14.0066 7.36329 14 6C14 4.4087 13.3679 2.88258 12.2427 1.75736C11.1175 0.632141 9.59134 0 8.00004 0C6.40874 0 4.88262 0.632141 3.7574 1.75736C2.63218 2.88258 2.00004 4.4087 2.00004 6C1.9973 7.37381 2.47084 8.7061 3.34004 9.77L1.00004 18.75C0.950264 18.9419 0.958671 19.1443 1.02419 19.3315C1.08971 19.5186 1.20939 19.6821 1.36802 19.801C1.52664 19.92 1.71706 19.9891 1.91506 19.9996C2.11306 20.0101 2.30972 19.9615 2.48004 19.86L7.81004 16.73L13.49 19.87C13.6435 19.9626 13.8209 20.0078 14 20C14.1553 20.005 14.3096 19.9737 14.4507 19.9086C14.5918 19.8435 14.7157 19.7465 14.8128 19.6252C14.9098 19.5039 14.9773 19.3616 15.0098 19.2097C15.0423 19.0578 15.039 18.9004 15 18.75ZM8.00004 2C8.79116 2 9.56452 2.2346 10.2223 2.67412C10.8801 3.11365 11.3928 3.73836 11.6956 4.46927C11.9983 5.20017 12.0775 6.00444 11.9232 6.78036C11.7688 7.55629 11.3879 8.26902 10.8285 8.82843C10.2691 9.38784 9.55632 9.7688 8.7804 9.92314C8.00447 10.0775 7.20021 9.99827 6.4693 9.69552C5.7384 9.39277 5.11369 8.88008 4.67416 8.22228C4.23463 7.56448 4.00004 6.79113 4.00004 6C4.00004 4.93913 4.42146 3.92172 5.17161 3.17157C5.92176 2.42143 6.93917 2 8.00004 2ZM8.31004 14.71C8.15802 14.6222 7.98557 14.576 7.81004 14.576C7.6345 14.576 7.46206 14.6222 7.31004 14.71L3.56004 16.91L5.00004 11.21C5.90065 11.7276 6.92126 12 7.96004 12C8.99881 12 10.0194 11.7276 10.92 11.21L12.45 17L8.31004 14.71Z"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconAward',
}
</script>
